import React, { useState, useContext, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import AppNavbar from '../../components/Navbar';
import { Container, Card, Button, Form , Col, Row, } from 'react-bootstrap';
import './booking.css'
import plane from '../../images/airplane.png'
import airplane from '../../images/airplane-col.png'
import location from '../../images/location-col.png'
import calendar from '../../images/calendar-2.png'
import hotel from '../../images/home.png'
import hotelLG from '../../images/hotel.png'
import { flightType, passengers, flightClasses,locations } from '../../data';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import aeroplane from '../../images/aeroplane.png'
import { CloseButton} from 'react-bootstrap';
import Chatbot from 'react-chatbot-kit';

import 'react-chatbot-kit/build/main.css'
import config from '../../chatbot/config';
import ActionProvider from '../../chatbot/ActionProvider';
import MessageParser from '../../chatbot/MessageParser';
import chatIcon from '../../images/chat-icon.svg'
import AppContext from '../../AppContext';


const Booking = () => {
  const { departureLocation, setDepartureLocation, arrivalLocation, setArrivalLocation, hotelLocation, setHotelLocation,departureDate, setDepartureDate,arrivalDate, setArrivalDate, checkInDate, setCheckInDate, checkOutDate, setCheckOutDate, trip, setTrip,
    flightClass, setFlightClass,
    passenger, setPassenger,
    adultNo, setAdultNo,
    childrenNo, setChildrenNo,
    rooms, setRooms} = useContext(AppContext);
    const [image, setImage] = useState(aeroplane);
      const [selectedButton, setSelectedButton] = useState(0);
      
     
      const [showDatePicker, setShowDatePicker] = useState(false);
      const [showDatePicker2, setShowDatePicker2] = useState(false);
     const navigate= useNavigate();
     const [isFormValid, setIsFormValid] = useState(false);
    
     useEffect(() => {
      validateForm();
    }, [departureLocation,arrivalLocation,passenger,flightClass,trip,departureDate]);
    useEffect(() => {
      validateForm2();
    }, [hotelLocation,rooms,childrenNo,adultNo,checkInDate,checkOutDate]);
     
      const handleDateClick = () => {
        setShowDatePicker(true);
      };
      const handleDateClick2 = () => {
          setShowDatePicker2(true);
        };
    
        const formatDateToWords = (date) => {
          const options = {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          };
          return date.toLocaleDateString(undefined, options);
        };
      const handleDateChange = (date) => {
       setDepartureDate(date);
        setShowDatePicker(false);
        
      };
  
      const handleDateChange2 = (date) => {
          setArrivalDate(date);
          setShowDatePicker2(false);
          
        };
  
        const handleDateChange3 = (date) => {
          setCheckInDate(date);
          setShowDatePicker(false);
          
        };
  
        const handleDateChange4 = (date) => {
          setCheckOutDate(date);
          setShowDatePicker2(false);
          // 
        };
  
  
      const handleTripChange = (event) => {
          setTrip(event.target.value);
          
         
        };
        const handleAdultNoChange = (event) => {
          setAdultNo(event.target.value);
          
         
        };
        const handleChildrenNoChange = (event) => {
          setChildrenNo(event.target.value);
          
        };
        const handleRoomsChange = (event) => {
          setRooms(event.target.value);
          
        };
        const handleDepartureChange = (event) => {
          setDepartureLocation(event.target.value);
          
        };
        const handleArrivalChange = (event) => {
          setArrivalLocation(event.target.value);
          
        };
        const handleHotelChange = (event) => {
          setHotelLocation(event.target.value);
          
        };
        const handleClassChange = (event) => {
          setFlightClass(event.target.value);
          
        };
        const handlePassengerChange = (event) => {
          setPassenger(event.target.value);
          
        };
  
    const handleButtonClick = (newImage,buttonIndex) => {
      setImage(newImage);
      setSelectedButton(buttonIndex);
    };
  
    const handleFlightSubmit = (event) => {
      event.preventDefault();
      if(isFormValid){navigate('/signup')}
      
    
    };

    const handleHotelSubmit = (event) => {
        event.preventDefault();
        if(isFormValid){navigate('/signup')}
          
      
      };
  
    const validateForm = () => {
      setIsFormValid(departureLocation !== '' && arrivalLocation !== '' && passenger !== '' && flightClass !== '' && trip !== '' && departureDate !== ''  );
    };
    const validateForm2 = () => {
      setIsFormValid(hotelLocation !== '' && rooms !== '' && childrenNo !== '' && adultNo !== '' && checkInDate !== '' && checkOutDate !== ''  );
    };
  
    return (
     <div>
      <AppNavbar/>
    <div>
         
          <Card className='border-0 bg-white all-container d-none d-sm-block' >
          <Card.Img src={image} alt='image' style={{maxHeight:'500px'}} className='d-none d-sm-block'/>
          <Card.ImgOverlay className='p-3 p-md-5 mt-md-5 '>
        <div className='p-lg-5 mt-lg-5 ' >
          <div className='d-flex gap-4 px-sm-4 py-4 bg-white '>
            <button className={selectedButton === 0 ? 'active booking-button' : 'booking-button'} onClick={() => handleButtonClick(aeroplane,0)}><img src={plane} alt='aeroplane'/>
              Flights
              </button>
              <button className={selectedButton === 1 ? 'active booking-button' : 'booking-button'} onClick={() => handleButtonClick(hotelLG,1)}> <img src={hotel} alt='hotel'/>
              Find Hotels
              </button>
            </div>
            <div className=''>
              {selectedButton === 0 && (
                  <Card style={{background: '#008080', borderRadius: 'none'}} className='p-4 p-md-5 border-0'>
                      <Form onSubmit={handleFlightSubmit}>
                      <div className='d-block d-sm-flex gap-2'>
                      <Form.Select className='mb-2 p-2 flight-select' value={trip}  onChange={handleTripChange} isValid={trip !== ''}
            isInvalid={trip === ''}>
                       
                       <option value="">Select trip type</option>
          <option value="round">Round Trip</option>
          <option value="one-way">One Way</option>
  
                      </Form.Select>
                      <Form.Select className='mb-2 p-2 flight-select' value={passenger}  onChange={handlePassengerChange} isValid={passenger !== ''}
            isInvalid={passenger === ''}>
                      <option value="">Select passenger</option>
                      {passengers.map((passenger) => (
                          <option key={passenger} value={passenger}>{passenger}</option>
                      ))}
  
                      </Form.Select>
                      <Form.Select className='mb-2 p-2 flight-select' value={flightClass}  onChange={handleClassChange} isValid={flightClass !== ''}
            isInvalid={flightClass === ''}>
                     <option value="">Select flight class</option>
                     {flightClasses.map((flightclass) => (
                         <option key={flightclass} value={flightclass} >{flightclass}</option>
                     ))}
  
                     </Form.Select>
                      
                      
                      </div>
                      <Row className='mt-3 g-2'>
                          <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex p-2 gap-2 align-items-center locate' style={{ background:'#fff'}}>
                              <img src={airplane} alt='airplane' style={{width:'30px', height:'30px'}}/>
                              <div>
                                  <p className='pe-3'>From ?</p>
                                  <Form.Select className='border-0'  value={departureLocation}
            onChange={handleDepartureChange} isValid={departureLocation !== ''}
            isInvalid={departureLocation === ''}>
                 <option>Location</option>
                 
                 {locations.map((location) => (
              <option key={location} value={location}>
               {location}, Nigeria
              </option>
              ))}
                  </Form.Select>
                                 
                              </div>
    </div>                   </Col>
                          <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                              <img src={location} alt='location' style={{width:'30px', height:'30px'}}/>
                              <div>
                                  <p className='pe-3'>To ?</p>
                                  <Form.Select className='border-0'  value={arrivalLocation}
            onChange={handleArrivalChange} isValid={arrivalLocation !== ''}
            isInvalid={arrivalLocation === ''}>
                 <option>Location</option>
                 
                 {locations.map((location) => (
              <option key={location} value={location}>
                {location}, Nigeria
              </option>
              ))}
                  </Form.Select>
                                 
                              </div>
   </div>                       </Col>
                          <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                              <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
                              <div>
                                  <p className='pe-2'>Departure</p>
                                  <Form.Group>                           <Form.Control type="text"
          value={formatDateToWords(departureDate)}
          onClick={handleDateClick}
          readOnly className='border-0' isValid={departureDate !== ''}
          isInvalid={departureDate === ''}/>
          {showDatePicker && (
          <ReactDatePicker
            selected={departureDate}
            onChange={handleDateChange}
            dateFormat="MM/dd/yyyy"
            onClickOutside={() => setShowDatePicker(false)}  
          />
        )}
                           </Form.Group>  
                                
                                 
                              </div>
  </div>                       </Col>
  {trip === 'round' && (
   <Col xs={12} sm={6} md={6} lg={3} > <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
   <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
   <div>
       <p className='pe-2'>Return</p>
       <Form.Group>                           <Form.Control type="text"
value={formatDateToWords(arrivalDate)}
onClick={handleDateClick2}
readOnly className='border-0' isValid={arrivalDate !== ''}
isInvalid={arrivalDate === ''}/>
{showDatePicker2 && (
<ReactDatePicker
selected={arrivalDate}
onChange={handleDateChange2}
dateFormat="MM/dd/yyyy"
onClickOutside={() => setShowDatePicker2(false)}  
/>
)}
</Form.Group>  
     
      
   </div>
</div>                        </Col>
  )}
                          
                      </Row>
                      <div className='mt-5 text-center'>
                      <button type='submit'  disabled={!isFormValid} className='subscribe-button border-0' style={{width:'250px'}}>Search for flights</button>
                      </div>
                      </Form>
                  </Card>
              )}
              {selectedButton === 1 && (
                  <Card style={{background: '#008080', borderRadius: 'none'}} className='p-5 border-0'>
                      <Form onSubmit={handleHotelSubmit}>
                  <div className='d-block d-sm-flex gap-2'>
                  <Form.Select className='mb-2 p-2 flight-select' value={adultNo}  onChange={handleAdultNoChange}  isValid={adultNo !== ''}
          isInvalid={adultNo === ''}>
                  <option>Adult</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
  
                  </Form.Select>
                  <Form.Select className='mb-2 p-2 flight-select' value={childrenNo}  onChange={handleChildrenNoChange} isValid={childrenNo !== ''}
          isInvalid={childrenNo === ''}>
                  <option>Children</option>
        <option value="1">1</option>
        <option value="2 and more">2 and more</option>
        <option value="None">None</option>
  
                  </Form.Select>
                  <Form.Select className='mb-2 p-2 flight-select' value={rooms}  onChange={handleRoomsChange} isValid={rooms !== ''}
          isInvalid={rooms === ''}>
                  <option>Rooms</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="Many">Many</option>
  
                  </Form.Select>
                  
                  
                  </div>
                  <Row className='mt-3 g-2'>
                     
                      <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={location} alt='location' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-3'>From ?</p>
                              <Form.Select className='border-0'  value={hotelLocation}
        onChange={handleHotelChange} isValid={hotelLocation !== ''}
        isInvalid={hotelLocation === ''}>
             <option>Location</option>
             
             {locations.map((location) => (
          <option key={location} value={location}>
            {location}, Nigeria
          </option>
          ))}
              </Form.Select>
                             
                          </div>
  </div>                       </Col>
                      <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-2'>Check-in date</p>
                              <Form.Group>                           <Form.Control type="text"
      value={formatDateToWords(checkInDate)}
      onClick={handleDateClick}
      readOnly className='border-0' isValid={checkInDate !== ''}
      isInvalid={checkInDate === ''}/>
      {showDatePicker && (
      <ReactDatePicker
        selected={checkInDate}
        onChange={handleDateChange3}
        dateFormat="MM/dd/yyyy"
        onClickOutside={() => setShowDatePicker(false)}  
      />
    )}
                       </Form.Group>  
                            
                             
                          </div>
  </div>                       </Col>
                      <Col xs={12} sm={6} md={6} lg={3} > <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-2'>Check-out date</p>
                              <Form.Group>                           <Form.Control type="text"
       value={formatDateToWords(checkOutDate)}
      onClick={handleDateClick2}
      readOnly className='border-0'  isValid={checkOutDate !== ''}
      isInvalid={checkOutDate === ''}/>
      {showDatePicker2 && (
      <ReactDatePicker
        selected={checkOutDate}
        onChange={handleDateChange4}
        dateFormat="MM/dd/yyyy"
        onClickOutside={() => setShowDatePicker2(false)}  
      />
    )}
                       </Form.Group>  
                            
                             
                          </div>
  </div>                        </Col>
                  </Row>
                  <div className='mt-5 text-center'>
                  <button type='submit'  disabled={!isFormValid} className='subscribe-button border-0' style={{width:'250px'}}>Search for hotels</button>
                  </div>
                  </Form>
              </Card>
              )}
            </div>
          </div>
        
      </Card.ImgOverlay>
          </Card>
          <div className='p-3 mb-5 d-block d-sm-none'>
          <div className='p-lg-5 mt-lg-5 ' >
          <div className='d-flex gap-4 px-sm-4 py-4 bg-white '>
            <button className={selectedButton === 0 ? 'active booking-button' : 'booking-button'} onClick={() => handleButtonClick(aeroplane,0)}><img src={plane} alt='aeroplane'/>
              Flights
              </button>
              <button className={selectedButton === 1 ? 'active booking-button' : 'booking-button'} onClick={() => handleButtonClick(hotelLG,1)}> <img src={hotel} alt='hotel'/>
              Find Hotels
              </button>
            </div>
            <div className=''>
              {selectedButton === 0 && (
                  <Card style={{background: '#008080', borderRadius: 'none'}} className='p-4 p-md-5 border-0'>
                      <Form onSubmit={handleFlightSubmit}>
                      <div className='d-block d-sm-flex gap-2'>
                      <Form.Select className='mb-2 p-2 flight-select' value={trip}  onChange={handleTripChange} isValid={trip !== ''}
            isInvalid={trip === ''}>
                       
                       <option value="">Select trip type</option>
          <option value="round">Round Trip</option>
          <option value="one-way">One Way</option>
  
                      </Form.Select>
                      <Form.Select className='mb-2 p-2 flight-select' value={passenger}  onChange={handlePassengerChange} isValid={passenger !== ''}
            isInvalid={passenger === ''}>
                      <option value="">Select passenger</option>
                      {passengers.map((passenger) => (
                          <option key={passenger} value={passenger}>{passenger}</option>
                      ))}
  
                      </Form.Select>
                      <Form.Select className='mb-2 p-2 flight-select' value={flightClass}  onChange={handleClassChange} isValid={flightClass !== ''}
            isInvalid={flightClass === ''}>
                     <option value="">Select flight class</option>
                     {flightClasses.map((flightclass) => (
                         <option key={flightclass} value={flightclass} >{flightclass}</option>
                     ))}
  
                     </Form.Select>
                      
                      
                      </div>
                      <Row className='mt-3 g-2'>
                          <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex p-2 gap-2 align-items-center locate' style={{ background:'#fff'}}>
                              <img src={airplane} alt='airplane' style={{width:'30px', height:'30px'}}/>
                              <div>
                                  <p className='pe-3'>From ?</p>
                                  <Form.Select className='border-0'  value={departureLocation}
            onChange={handleDepartureChange} isValid={departureLocation !== ''}
            isInvalid={departureLocation === ''}>
                 <option>Location</option>
                 
                 {locations.map((location) => (
              <option key={location} value={location}>
               {location}, Nigeria
              </option>
              ))}
                  </Form.Select>
                                 
                              </div>
    </div>                   </Col>
                          <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                              <img src={location} alt='location' style={{width:'30px', height:'30px'}}/>
                              <div>
                                  <p className='pe-3'>To ?</p>
                                  <Form.Select className='border-0'  value={arrivalLocation}
            onChange={handleArrivalChange} isValid={arrivalLocation !== ''}
            isInvalid={arrivalLocation === ''}>
                 <option>Location</option>
                 
                 {locations.map((location) => (
              <option key={location} value={location}>
                {location}, Nigeria
              </option>
              ))}
                  </Form.Select>
                                 
                              </div>
   </div>                       </Col>
                          <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                              <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
                              <div>
                                  <p className='pe-2'>Departure</p>
                                  <Form.Group>                           <Form.Control type="text"
          value={formatDateToWords(departureDate)}
          onClick={handleDateClick}
          readOnly className='border-0' isValid={departureDate !== ''}
          isInvalid={departureDate === ''}/>
          {showDatePicker && (
          <ReactDatePicker
            selected={departureDate}
            onChange={handleDateChange}
            dateFormat="MM/dd/yyyy"
            onClickOutside={() => setShowDatePicker(false)}  
          />
        )}
                           </Form.Group>  
                                
                                 
                              </div>
  </div>                       </Col>
  {trip === 'round' && (
   <Col xs={12} sm={6} md={6} lg={3} > <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
   <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
   <div>
       <p className='pe-2'>Return</p>
       <Form.Group>                           <Form.Control type="text"
value={formatDateToWords(arrivalDate)}
onClick={handleDateClick2}
readOnly className='border-0' isValid={arrivalDate !== ''}
isInvalid={arrivalDate === ''}/>
{showDatePicker2 && (
<ReactDatePicker
selected={arrivalDate}
onChange={handleDateChange2}
dateFormat="MM/dd/yyyy"
onClickOutside={() => setShowDatePicker2(false)}  
/>
)}
</Form.Group>  
     
      
   </div>
</div>                        </Col>
  )}
                          
                      </Row>
                      <div className='mt-5 text-center'>
                      <button type='submit'  disabled={!isFormValid} className='subscribe-button border-0' style={{width:'250px'}}>Search for flights</button>
                      </div>
                      </Form>
                  </Card>
              )}
              {selectedButton === 1 && (
                  <Card style={{background: '#008080', borderRadius: 'none'}} className='p-5 border-0'>
                      <Form onSubmit={handleHotelSubmit}>
                  <div className='d-block d-sm-flex gap-2'>
                  <Form.Select className='mb-2 p-2 flight-select' value={adultNo}  onChange={handleAdultNoChange}  isValid={adultNo !== ''}
          isInvalid={adultNo === ''}>
                  <option>Adult</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
  
                  </Form.Select>
                  <Form.Select className='mb-2 p-2 flight-select' value={childrenNo}  onChange={handleChildrenNoChange} isValid={childrenNo !== ''}
          isInvalid={childrenNo === ''}>
                  <option>Children</option>
        <option value="1">1</option>
        <option value="2 and more">2 and more</option>
        <option value="None">None</option>
  
                  </Form.Select>
                  <Form.Select className='mb-2 p-2 flight-select' value={rooms}  onChange={handleRoomsChange} isValid={rooms !== ''}
          isInvalid={rooms === ''}>
                  <option>Rooms</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="Many">Many</option>
  
                  </Form.Select>
                  
                  
                  </div>
                  <Row className='mt-3 g-2'>
                     
                      <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={location} alt='location' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-3'>From ?</p>
                              <Form.Select className='border-0'  value={hotelLocation}
        onChange={handleHotelChange} isValid={hotelLocation !== ''}
        isInvalid={hotelLocation === ''}>
             <option>Location</option>
             
             {locations.map((location) => (
          <option key={location} value={location}>
            {location}, Nigeria
          </option>
          ))}
              </Form.Select>
                             
                          </div>
  </div>                       </Col>
                      <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-2'>Check-in date</p>
                              <Form.Group>                           <Form.Control type="text"
      value={formatDateToWords(checkInDate)}
      onClick={handleDateClick}
      readOnly className='border-0' isValid={checkInDate !== ''}
      isInvalid={checkInDate === ''}/>
      {showDatePicker && (
      <ReactDatePicker
        selected={checkInDate}
        onChange={handleDateChange3}
        dateFormat="MM/dd/yyyy"
        onClickOutside={() => setShowDatePicker(false)}  
      />
    )}
                       </Form.Group>  
                            
                             
                          </div>
  </div>                       </Col>
                      <Col xs={12} sm={6} md={6} lg={3} > <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-2'>Check-out date</p>
                              <Form.Group>                           <Form.Control type="text"
       value={formatDateToWords(checkOutDate)}
      onClick={handleDateClick2}
      readOnly className='border-0'  isValid={checkOutDate !== ''}
      isInvalid={checkOutDate === ''}/>
      {showDatePicker2 && (
      <ReactDatePicker
        selected={checkOutDate}
        onChange={handleDateChange4}
        dateFormat="MM/dd/yyyy"
        onClickOutside={() => setShowDatePicker2(false)}  
      />
    )}
                       </Form.Group>  
                            
                             
                          </div>
  </div>                        </Col>
                  </Row>
                  <div className='mt-5 text-center'>
                  <button type='submit'  disabled={!isFormValid} className='subscribe-button border-0' style={{width:'250px'}}>Search for hotels</button>
                  </div>
                  </Form>
              </Card>
              )}
            </div>
          </div>
          </div>
     </div>
      </div>
      
    )
  }

export default Booking
